import React, { useState } from "react";
import FilterButton from "../partials/actions/FilterButton";
import AddEditPopup from "../partials/dashboard/AddEditPopup";
import UserManagementTable from "../partials/dashboard/UserManagementTable";
function UsersManagement() {
  const [showPopup, setShowPopup] = useState(false);
  const [click, setClick] = useState(false);
  const [lastLogin, setLastLogin] = useState(false);
  const [enrollmentDate, setEnrollmentDate] = useState(false);
  const [organization, setOrganization] = useState(false);
  const [plan, setPlan] = useState(false);
  const [search, setSearch] = useState("");
  const [userType, setUserType] = useState("all");
  const [planType, setPlanType] = useState("all");
  const [statusType, setStatusType] = useState("");

  


  const handleClosePopup = () => {
    setShowPopup(false);
  };
  const handleAdd = () => {
    setShowPopup(true);
  };

  return (
    <>
      {/* Dashboard actions */}
            <div className=" flex justify-end mb-8">


              {/* Right: Actions */}
              <div className="grid grid-flow-col sm:auto-cols-max justify-end sm:justify-end gap-2">
                {/* Filter button */}
                <FilterButton
                  setSearch={setSearch}
                  search={search}
                  lastLogin={lastLogin}
                  setLastLogin={setLastLogin}
                  userType={userType}
                  setUserType={setUserType}
                  setPlanType={setPlanType}
                  statusType={statusType} 
                  setStatusType={setStatusType}
                  planType={planType}
                  enrollmentDate={enrollmentDate}
                  setEnrollmentDate={setEnrollmentDate}
                  setOrganization={setOrganization}
                  organization={organization}
                  plan={plan}
                  setPlan={setPlan}
                />
                {/* Datepicker built with flatpickr */}
                {/*<Datepicker />*/}
                {/* Add view button */}
                {/*<button className="btn bg-indigo-500 hover:bg-indigo-600 text-white" onClick={() => handleAdd()}>
                  <svg
                    className="w-4 h-4 fill-current opacity-50 shrink-0"
                    viewBox="0 0 16 16"
                  >
                    <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                  </svg>
                  <span className="hidden xs:block ml-2">Add User</span>
                 </button>*/}
              </div>
            </div>

            {/* Cards */}
            <div className="grid grid-cols-12 gap-6">
              <UserManagementTable
                search={search}
                click={click}
                lastLogin={lastLogin}
                setLastLogin={setLastLogin}
                userType={userType}
                setUserType={setUserType}
                setPlanType={setPlanType}
                statusType={statusType} 
                setStatusType={setStatusType}
                planType={planType}
                enrollmentDate={enrollmentDate}
                setEnrollmentDate={setEnrollmentDate}
                setOrganization={setOrganization}
                organization={organization}
                plan={plan}
                setPlan={setPlan}
              />
            </div>
      {showPopup && (
        <AddEditPopup customer={null} onClose={handleClosePopup} />
      )}
    </>
  );
}

export default UsersManagement;
